import * as React from "react";
import { useTheme } from "@emotion/react";
import { forwardRef } from "react";
import { css, cx } from "@emotion/css";
const SvgUserArrowRotate = forwardRef(({
  title,
  titleId,
  desc,
  descId,
  ...props
}, ref) => {
  const theme = useTheme();
  let {
    color,
    colorSecondary,
    size,
    sizeH,
    sizeW,
    height: heightProp,
    width: widthProp,
    shadow,
    animatedProps,
    hex,
    ...other
  } = props;
  const height = heightProp ?? theme.iconSizes?.[sizeH ?? size];
  if (height) {
    other.height = height;
  }
  const width = widthProp ?? theme.iconSizes?.[sizeW ?? size];
  if (width) {
    other.width = isNaN(width) ? "100%" : width;
  }
  let fill = other.fill ?? theme.color?.icon[color];
  let fillSecondary = other.fillSecondary ?? theme.color?.icon[colorSecondary];
  delete other.fill;
  delete other.fillSecondary;
  const { className: classNameProp } = other;
  const className = css({
    filter: shadow ? theme.shadows.drop : void 0,
    minHeight: height,
    minWidth: width,
    clipPath: hex ? "url(#rounded-hex-clip-path)" : void 0
  });
  other.className = cx(className, classNameProp);
  if (color === "heading") {
    fill = "url(#harmony-gradient)";
  }
  ;
  other.role = title ? "img" : void 0;
  other["aria-hidden"] = title ? void 0 : true;
  props = {
    ...other,
    ref,
    fill
  };
  return /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, "aria-describedby": descId, ...props }, desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M21.625 10.4585C21.625 9.0901 20.6824 7.89426 19.2783 7.24768L19.225 7.29265C18.5864 7.81823 17.7677 8.13391 16.875 8.13391C15.9572 8.13391 15.1176 7.80022 14.4717 7.24768C13.0675 7.89426 12.125 9.0901 12.125 10.4585C12.125 12.5138 21.625 12.5138 21.625 10.4585Z", fill: props.fill }), /* @__PURE__ */ React.createElement("path", { d: "M19.5139 4.63158C19.5139 3.1782 18.3324 2 16.875 2C15.4176 2 14.2361 3.1782 14.2361 4.63158C14.2361 6.08496 15.4176 7.26316 16.875 7.26316C18.3324 7.26316 19.5139 6.08496 19.5139 4.63158Z", fill: props.fill }), /* @__PURE__ */ React.createElement("path", { d: "M13.2336 4.63158C13.2336 4.23863 13.296 3.8604 13.4115 3.50617C10.767 3.08292 7.94349 3.88309 5.84496 5.90668L4.54341 4.60513C3.96955 4.03127 2.98671 4.37698 2.89847 5.18373L2.38088 9.91599C2.31365 10.5306 2.8326 11.0495 3.44722 10.9823L8.17948 10.4647C8.98622 10.3765 9.33193 9.39365 8.75807 8.8198L7.58049 7.64221C9.16394 6.05876 11.4757 5.53982 13.5366 6.08539C13.3417 5.64038 13.2336 5.14874 13.2336 4.63158Z", fill: props.fill }), /* @__PURE__ */ React.createElement("path", { d: "M12.8798 20.4874C14.7995 20.2864 16.6566 19.449 18.0501 18.0554L19.3794 19.3847C19.9484 19.9537 20.9228 19.6193 21.0226 18.8209L21.6174 14.063C21.6948 13.4434 21.1735 12.914 20.5527 12.9819L15.8396 13.4974C15.0328 13.5856 14.6871 14.5684 15.261 15.1423L16.4386 16.3199C15.2629 17.4956 13.6857 18.0844 12.1078 18.0864C12.5899 18.7674 12.88 19.5719 12.88 20.461C12.88 20.4698 12.8799 20.4786 12.8798 20.4874Z", fill: props.fill }), /* @__PURE__ */ React.createElement("path", { d: "M11.875 20.4585C11.875 19.0901 10.9325 17.8943 9.52828 17.2477L9.475 17.2927C8.83638 17.8182 8.01767 18.1339 7.125 18.1339C6.20722 18.1339 5.36761 17.8002 4.72172 17.2477C3.31755 17.8943 2.375 19.0901 2.375 20.4585C2.375 22.5138 11.875 22.5138 11.875 20.4585Z", fill: props.fill }), /* @__PURE__ */ React.createElement("path", { d: "M9.76389 14.6316C9.76389 13.1782 8.58242 12 7.125 12C5.66758 12 4.48611 13.1782 4.48611 14.6316C4.48611 16.085 5.66758 17.2632 7.125 17.2632C8.58242 17.2632 9.76389 16.085 9.76389 14.6316Z", fill: props.fill }));
});
export default SvgUserArrowRotate;
